/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import { changePassword } from "api/api_register2FA";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Box, Snackbar, Typography } from "@mui/material";
import InputPassword from "components/InputPasswordCustome";

function ConfirmResetPass({ username }) {
  const navigate = useNavigate();
  const [passwordRules, setPasswordRules] = useState([
    { label: "Có ít nhất 8 ký tự", status: false },
    { label: "Có cả IN HOA và thường", status: false },
    { label: "Có ít nhất một số", status: false },
    { label: "Và một ký tự đặc biệt: !@#$%^&*", status: false },
  ]);
  const validatePassword = (password) => {
    const rulesCopy = [...passwordRules];
    rulesCopy[0].status = password.length >= 8;
    rulesCopy[1].status = /[a-z]/.test(password) && /[A-Z]/.test(password);
    rulesCopy[2].status = /\d/.test(password);
    rulesCopy[3].status = /[!@#$%^&*]/.test(password);

    setPasswordRules(rulesCopy);

    return rulesCopy.every((rule) => rule.status);
  };
  const [error, setError] = useState("");
  const [typePasswordNew, setTypePasswordNew] = useState({
    password: "",
    showPassword: true,
  });
  const [reTypePasswordNew, setReTypePasswordNew] = useState({
    password: "",
    showPassword: true,
  });
  const [isBackButtonClicked, setBackbuttonPress] = useState(false);
  const [isResetPasswordSuccess, setIsResetPasswordSuccess] = useState(true);

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (isBackButtonClicked) {
      setBackbuttonPress(false);
    } else {
      window.history.pushState(null, null, window.location.pathname);
      setBackbuttonPress(true);
    }
  };
  const handleCloseNotifyLogin = () => setIsResetPasswordSuccess(true);
  const resetPassword = async () => {
    const res = await changePassword(username, typePasswordNew.password);
    if (res) {
      alert("Đổi mật khẩu thành công");
      navigate("/authentication/sign-in");
    }
  };
  const handleResetPassword = () => {
    if (!validatePassword(typePasswordNew.password)) {
      setError("Mật khẩu mới phải đủ 8 ký tự, có cả chữ in hoa, chữ thường, số và ký tự đặc biệt.");
      setIsResetPasswordSuccess(false);
      return;
    }

    if (typePasswordNew.password !== reTypePasswordNew.password) {
      setError("Mật khẩu mới không khớp.");
      setIsResetPasswordSuccess(false);
      return;
    }
    resetPassword();
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);
  return (
    <SuiBox sx={{ display: "flex", justifyContent: "center", paddingTop: "150px" }}>
      <Box style={{ width: "550px" }}>
        <SuiBox sx={{ display: "flex", alignItems: "center" }} className="flex-column">
          <Typography sx={{ fontWeight: 700, fontSize: 25 }}>Đặt lại mật khẩu</Typography>
          <SuiBox sx={{ display: "flex" }}>
            <Typography sx={{ fontSize: 14 }}>Trở về </Typography>
            <Typography
              component={Link}
              to="/authentication/sign-in"
              variant="button"
              sx={{
                fontSize: 14,
                marginLeft: "6px",
                fontWeight: "regular",
                color: "var(--blue-blue-100)",
                cursor: "pointer",
                textTransform: "none",
              }}
            >
              Đăng nhập
            </Typography>
          </SuiBox>
        </SuiBox>
        <SuiBox className="w-100">
          <SuiBox component="form" role="form">
            <SuiBox mb={1}>
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "var(--gray-100)",
                  fontWeight: "regular",
                  textTransform: "none",
                }}
                mb={0.7}
              >
                Nhập mật khẩu mới
              </Typography>
              <InputPassword
                placeholder="Nhập mật khẩu mới"
                value={typePasswordNew}
                onChange={setTypePasswordNew}
              />
            </SuiBox>
            <SuiBox mb={1.7}>
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "var(--gray-100)",
                  fontWeight: "regular",
                  textTransform: "none",
                }}
                mb={0.7}
              >
                Nhập lại mật khẩu mới
              </Typography>
              <InputPassword
                placeholder="Nhập lại mật khẩu mới"
                value={reTypePasswordNew}
                onChange={setReTypePasswordNew}
              />
            </SuiBox>
            <SuiBox mb={2} textAlign="center">
              <SuiButton
                size="small"
                color="var(--blue-blue-100)"
                circular
                sx={{
                  width: "100% !important",
                  background: "var(--blue-blue-100)",
                  borderRadius: "15px",
                  padding: "8px 24px",
                }}
                onClick={handleResetPassword}
              >
                <Typography whiteSpace="nowrap" variant="body2" color="white" fontSize="14px">
                  Đổi mật khẩu
                </Typography>
              </SuiButton>
            </SuiBox>
          </SuiBox>
        </SuiBox>
        {isResetPasswordSuccess === false && (
          <Snackbar
            open={!isResetPasswordSuccess}
            autoHideDuration={3000}
            onClose={handleCloseNotifyLogin}
          >
            <Alert severity="error" sx={{ width: "100%" }}>
              {error}
            </Alert>
          </Snackbar>
        )}
      </Box>
    </SuiBox>
  );
}
ConfirmResetPass.propTypes = {
  username: PropTypes.string,
};
ConfirmResetPass.defaultProps = {
  username: "",
};

export default ConfirmResetPass;
